import { SettingAPI } from "@griffingroupglobal/eslib-api";

const editSettingsHandler = async ({ newSettings }) => {
  const { data } = await SettingAPI.postWOP("$update", newSettings);

  return data;
};

export default editSettingsHandler;
